import { GetPageTitle } from "@/actions/search/services/AdSearchTitleService";
import { ParseUrl } from "@/actions/search/services/AdSearchUrlService";
import { useUserSaveType } from "@/app/layout/useUserSaves";
import {
  Box,
  CircularProgress,
  IconButton,
  MenuItem,
  Typography,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import Link from "next/link";
import { EmailSubscriptionSwitch } from "@/components/common/EmailSubscriptionSwitch";


function GetSearchTitleFromPath(searchPath: string): string {
  const slugs = searchPath.split("/").filter((s) => s.length > 0);
  const searchRequest = ParseUrl(slugs);
  const searchTitle = GetPageTitle(searchRequest);
  return searchTitle;
}

function BlockClickEvent(event: React.MouseEvent) {
  event.stopPropagation();
  event.preventDefault();
  event.nativeEvent.stopImmediatePropagation();
}

export function SavedSearchesList({ searchPath }: { searchPath?: string }) {
  const { userSaves, status, RemoveUserSave, ToggleSubscribed } =
    useUserSaveType("SEARCH");
  return (
    <>
      {status !== "ready" ? (
        <CircularProgress />
      ) : (
        <>
          {userSaves.length === 0 ? (
            <Typography>You don&apos;t have any saved searches.</Typography>
          ) : (
            <>
              {userSaves.map((save) => (
                <MenuItem
                  key={save.key}
                  component={Link}
                  href={`/for-sale/${save.key}`}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight:
                        searchPath && searchPath === save.key
                          ? "bold"
                          : "normal",
                      whiteSpace: "normal",
                    }}
                  >
                    {GetSearchTitleFromPath(save.key)}
                  </Typography>
                  <Box
                    sx={{
                      marginLeft: "auto",
                    }}
                  >
                    <EmailSubscriptionSwitch
                      onClick={async (e) => {
                        BlockClickEvent(e);
                        await ToggleSubscribed(save.key);
                      }}
                      checked={!save.isUnsubscribed}
                    />
                  </Box>
                  <IconButton
                    onClick={async (e) => {
                      BlockClickEvent(e);
                      await RemoveUserSave(save.key);
                    }}
                    sx={{
                      margin: -1,
                    }}
                  >
                    <ClearIcon />
                  </IconButton>
                </MenuItem>
              ))}
            </>
          )}
        </>
      )}
    </>
  );
}
